<template>
  <PopDialog2
    title="방 정보 수정"
    :visible="props.visible"
    :okCallback="onOkClick"
    :cancelCallback="onCancelClick"
  >
    <div class="md-layout">
      <div class="md-layout-item md-size-50 mx-auto text-center mb-4">
        <h2 class="title mt-4 mb-4">장치 설정</h2>

        <hr class="mb-3" />

        <template v-if="isCoolingMode">
          <div class="row mb-2 align-items-center">
            <div class="text-start col-5">바람세기</div>
            <div class="col">
              <div class="row g-1">
                <div class="col px-0">
                  <select v-model.number="airconWindSpeed" class="form-select form-select-sm touch-optimized">
                    <option v-for="option in windSpeedOptions" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>
                <div class="col-auto ps-1">
                  <button type="button" class="btn btn-primary btn-sm touch-optimized apply-btn" @click="onApplyWindSpeed">적용</button>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-2 align-items-center">
            <div class="text-start col-5">운전모드</div>
            <div class="col">
              <div class="row g-1">
                <div class="col px-0">
                  <select v-model.number="airconOperMode" class="form-select form-select-sm touch-optimized">
                    <option v-for="option in operModeOptions" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>
                <div class="col-auto ps-1">
                  <button type="button" class="btn btn-primary btn-sm touch-optimized apply-btn" @click="onApplyOperMode">적용</button>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-2 align-items-center">
            <div class="text-start col-5">실내기주소</div>
            <div class="col">
              <div class="row g-1">
                <div class="col px-0">
                  <input
                    v-model="airconIndoorAddress"
                    type="text"
                    class="form-control form-control-sm touch-optimized"
                    placeholder="03"
                  />
                </div>
                <div class="col-auto ps-1">
                  <button type="button" class="btn btn-primary btn-sm touch-optimized apply-btn" @click="onApplyIndoorAddress">적용</button>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-2 align-items-center">
            <div class="text-start col-5">실내기수량</div>
            <div class="col">
              <div class="row g-1">
                <div class="col px-0">
                  <input
                    v-model.number="airconCassetteCount"
                    type="number"
                    min="1"
                    max="6"
                    class="form-control form-control-sm touch-optimized"
                  />
                </div>
                <div class="col-auto ps-1">
                  <button type="button" class="btn btn-primary btn-sm touch-optimized apply-btn" @click="onApplyCassetteCount">적용</button>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-2 align-items-center">
            <div class="text-start col-5">게이트웨이주소</div>
            <div class="col">
              <div class="row g-1">
                <div class="col px-0">
                  <input
                    v-model.number="airconGwAddress"
                    type="number"
                    min="1"
                    max="247"
                    class="form-control form-control-sm touch-optimized"
                  />
                </div>
                <div class="col-auto ps-1">
                  <button type="button" class="btn btn-primary btn-sm touch-optimized apply-btn" @click="onApplyGwAddress">적용</button>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-2 align-items-center">
            <div class="text-start col-5">에어컨제조사</div>
            <div class="col">
              <div class="row g-1">
                <div class="col px-0">
                  <select v-model="airconProduct" class="form-select form-select-sm touch-optimized">
                    <option value="LG">LG</option>
                    <option value="Samsung">Samsung</option>
                  </select>
                </div>
                <div class="col-auto ps-1">
                  <button type="button" class="btn btn-primary btn-sm touch-optimized apply-btn" @click="onApplyProduct">적용</button>
                </div>
              </div>
            </div>
          </div>

          <hr class="mb-3" />

          <div class="setting-row touch-optimized" @click="onScheduleClick">
            <div class="setting-label setting-label-long">예약 냉방 설정</div>
            <div class="setting-field">
              <i class="fa fa-chevron-right setting-trailing-icon" />
            </div>
          </div>
        </template>

        <template v-else>
          <div class="boiler-settings">
            <div class="setting-row touch-optimized" @click="onScheduleClick">
              <div class="setting-label setting-label-long">예약 난방 설정</div>
              <div class="setting-field">
                <i class="fa fa-chevron-right setting-trailing-icon" />
              </div>
            </div>
            <div class="setting-row">
              <div class="setting-label setting-label-long">예약 난방 동기화 허용</div>
              <div class="setting-field">
                <div class="form-check form-switch m-0">
                  <input class="form-check-input touch-optimized" type="checkbox" role="switch" :checked="device.item.allowSync" @change="onAllowSyncChange">
                </div>
              </div>
            </div>
            <div class="setting-row">
              <div class="setting-label setting-label-long">패턴 난방 시간 x 2</div>
              <div class="setting-field">
                <div class="form-check form-switch m-0">
                  <input class="form-check-input touch-optimized" type="checkbox" role="switch" :checked="device.item.pattern2x" @change="onPattern2xChange">
                </div>
              </div>
            </div>
            <div class="setting-row">
              <div class="setting-label">온도 보정</div>
              <div class="setting-field">
                <div class="setting-controls">
                  <div class="setting-controls-main btn-group btn-group-sm">
                    <button type="button" class="btn btn-outline-primary touch-optimized setting-stepper-btn" @touchstart="onMinusClick" @click="onMinusClick">-</button>
                    <button type="button" class="btn btn-outline-primary touch-optimized setting-stepper-val">{{ calibration.toFixed(1) }}</button>
                    <button type="button" class="btn btn-outline-primary touch-optimized setting-stepper-btn" @touchstart="onPlusClick" @click="onPlusClick">+</button>
                  </div>
                  <div class="setting-controls-apply">
                    <button type="button" class="btn btn-primary touch-optimized" @touchstart="onApplyCalibrationClick" @click="onApplyCalibrationClick">적용</button>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="supportsDarkMode">
              <div class="dark-mode-hint text-muted">
                다크 1번: 시작시간에 꺼짐, 종료시간에 밝기 복귀<br />
                다크 2번: 시작시간에 꺼짐, 종료시간에도 복귀 않됨(터치로 복귀됨)
              </div>
              <div class="setting-row">
                <div class="setting-label">다크모드</div>
                <div class="setting-field">
                  <div class="setting-controls">
                    <div class="setting-controls-main">
                      <select v-model.number="darkMode" class="form-select form-select-sm touch-optimized dark-mode-select">
                        <option :value="0">비활성</option>
                        <option :value="1">1번</option>
                        <option :value="2">2번</option>
                      </select>
                    </div>
                    <div class="setting-controls-apply">
                      <button type="button" class="btn btn-primary touch-optimized" @click="onApplyDarkMode">적용</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="setting-row">
                <div class="setting-label">시작시간</div>
                <div class="setting-field">
                  <div class="setting-time-selects">
                    <select v-model.number="darkModeStartHour" class="form-select form-select-sm touch-optimized dark-mode-time-part">
                      <option v-for="h in darkModeHourOptions" :key="`s-h-${h.value}`" :value="h.value">{{ h.label }}</option>
                    </select>
                    <span class="dark-mode-time-sep">:</span>
                    <select v-model.number="darkModeStartMinute" class="form-select form-select-sm touch-optimized dark-mode-time-part">
                      <option v-for="m in darkModeMinuteOptions" :key="`s-m-${m.value}`" :value="m.value">{{ m.label }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="setting-row">
                <div class="setting-label">종료시간</div>
                <div class="setting-field">
                  <div class="setting-time-selects">
                    <select v-model.number="darkModeEndHour" class="form-select form-select-sm touch-optimized dark-mode-time-part">
                      <option v-for="h in darkModeHourOptions" :key="`e-h-${h.value}`" :value="h.value">{{ h.label }}</option>
                    </select>
                    <span class="dark-mode-time-sep">:</span>
                    <select v-model.number="darkModeEndMinute" class="form-select form-select-sm touch-optimized dark-mode-time-part">
                      <option v-for="m in darkModeMinuteOptions" :key="`e-m-${m.value}`" :value="m.value">{{ m.label }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
  </PopDialog2>
</template>

<script setup>
import { ref, defineProps, computed, getCurrentInstance, reactive, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { ButtonConfig, MQTTTempCommand } from '@/common/constants';
import {
  resolveTempControllerModel,
  isTempModelAtLeast,
} from '@/common/utils/tempControllerModel';
import useMqttControl from '@/common/hooks/useMqttControl';
import PopDialog2 from '@/common/components/popup/PopDialog2.vue';
import Axios, { DeviceApi, ScheduleApi } from '@/api';
import moment from 'moment';
import { buildTimerGroupMqttPayload } from '@/common/utils/scheduleMqtt';

const router = useRouter();
const mqttControl = reactive(useMqttControl());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();
const props = defineProps([
  'visible',
  'okCallback',
  'cancelCallback',
  'roomName',
  'roomId',
  'handlePowerClick'
]);

const zone = computed(() => {
  if (store.state.home.zones.length > 0) {
    return store.getters['home/getCurrentZone'];
  } else return null;
});
const group = computed(() => {
  return zone.value.groups.find((g) => g._id === props.roomId);
});
const devices = computed(() => {
  return group.value ? group.value.devices : undefined;
});
const boilerDevices = computed(() => {
  return devices.value.filter(
    (d) => d.type === 2,
  );
});
/** 가상장치보다 실제 온도조절기 장치를 우선 (모델/설정 대상) */
const device = computed(() => {
  if (!boilerDevices.value?.length) {
    return undefined;
  }
  return (
    boilerDevices.value.find((d) => !d.isVirtual) ||
    boilerDevices.value[0]
  );
});
const isCoolingMode = computed(() => {
  return device.value?.item?.hcMode === 1;
});

/** 다크모드 설정은 T02 이상에서만 지원 */
const TEMP_DARK_MODE_MIN_MODEL_NUM = 2;

const supportsDarkMode = computed(() => {
  return boilerDevices.value.some((dev) => {
    if (dev?.isVirtual) {
      return false;
    }
    const model = resolveTempControllerModel(dev, zone.value?.controllers);
    return isTempModelAtLeast(model, TEMP_DARK_MODE_MIN_MODEL_NUM);
  });
});

const calibration = ref(device.value?.item?.calibration || 0.0);

const normalizeTimeValue = (value, fallback) => {
  if (!value || typeof value !== 'string') return fallback;
  // Accept "HH:MM" or "HH:MM:SS" from input/DB
  const match = value.match(/^(\d{1,2}):(\d{2})/);
  if (!match) return fallback;
  let hour = Math.min(23, Math.max(0, parseInt(match[1], 10)));
  let minute = Math.min(59, Math.max(0, parseInt(match[2], 10)));
  // Snap to 10-minute steps
  minute = Math.round(minute / 10) * 10;
  if (minute === 60) {
    minute = 0;
    hour = (hour + 1) % 24;
  }
  const hh = String(hour).padStart(2, '0');
  const mm = String(minute).padStart(2, '0');
  return `${hh}:${mm}`;
};

const parseTimeParts = (value, fallback) => {
  const normalized = normalizeTimeValue(value, fallback);
  const [hh, mm] = normalized.split(':').map((v) => parseInt(v, 10));
  return { hour: hh, minute: mm };
};

const formatTimeParts = (hour, minute) => {
  const hh = String(Math.min(23, Math.max(0, Number(hour) || 0))).padStart(2, '0');
  const mm = String(Math.min(50, Math.max(0, Number(minute) || 0))).padStart(2, '0');
  return `${hh}:${mm}`;
};

const darkModeHourOptions = Array.from({ length: 24 }, (_, h) => ({
  value: h,
  label: String(h).padStart(2, '0'),
}));
const darkModeMinuteOptions = [0, 10, 20, 30, 40, 50].map((m) => ({
  value: m,
  label: String(m).padStart(2, '0'),
}));

const darkMode = ref(Number(device.value?.item?.darkMode ?? 0));
const darkModeStart = ref(normalizeTimeValue(device.value?.item?.darkModeStart, '21:00'));
const darkModeEnd = ref(normalizeTimeValue(device.value?.item?.darkModeEnd, '06:00'));

const darkModeStartHour = computed({
  get: () => parseTimeParts(darkModeStart.value, '21:00').hour,
  set: (hour) => {
    darkModeStart.value = formatTimeParts(hour, parseTimeParts(darkModeStart.value, '21:00').minute);
  },
});
const darkModeStartMinute = computed({
  get: () => parseTimeParts(darkModeStart.value, '21:00').minute,
  set: (minute) => {
    darkModeStart.value = formatTimeParts(parseTimeParts(darkModeStart.value, '21:00').hour, minute);
  },
});
const darkModeEndHour = computed({
  get: () => parseTimeParts(darkModeEnd.value, '06:00').hour,
  set: (hour) => {
    darkModeEnd.value = formatTimeParts(hour, parseTimeParts(darkModeEnd.value, '06:00').minute);
  },
});
const darkModeEndMinute = computed({
  get: () => parseTimeParts(darkModeEnd.value, '06:00').minute,
  set: (minute) => {
    darkModeEnd.value = formatTimeParts(parseTimeParts(darkModeEnd.value, '06:00').hour, minute);
  },
});

const getAirconItem = () => device.value?.item?.aircon || {};

const airconWindSpeed = ref(getAirconItem().windSpeed ?? 4);
const airconOperMode = ref(getAirconItem().operMode ?? 0);
const airconIndoorAddress = ref(getAirconItem().indoorAddress ?? '03');
const airconCassetteCount = ref(getAirconItem().cassetteCount ?? 1);
const airconGwAddress = ref(getAirconItem().gwAddress ?? 1);
const airconProduct = ref(getAirconItem().product ?? 'LG');

watch(device, () => {
  const aircon = getAirconItem();
  airconWindSpeed.value = aircon.windSpeed ?? 4;
  airconOperMode.value = aircon.operMode ?? 0;
  airconIndoorAddress.value = aircon.indoorAddress ?? '03';
  airconCassetteCount.value = aircon.cassetteCount ?? 1;
  airconGwAddress.value = aircon.gwAddress ?? 1;
  airconProduct.value = aircon.product ?? 'LG';
  calibration.value = device.value?.item?.calibration || 0.0;
  darkMode.value = Number(device.value?.item?.darkMode ?? 0);
  darkModeStart.value = normalizeTimeValue(device.value?.item?.darkModeStart, '21:00');
  darkModeEnd.value = normalizeTimeValue(device.value?.item?.darkModeEnd, '06:00');
});

const lgOperModeOptions = [
  { value: 0, label: '냉방' },
  { value: 1, label: '제습' },
  { value: 2, label: '송풍' },
  { value: 3, label: '자동' },
  { value: 4, label: '난방' },
];
const samsungOperModeOptions = [
  { value: 0, label: '자동' },
  { value: 1, label: '냉방' },
  { value: 2, label: '제습' },
  { value: 3, label: '송풍' },
  { value: 4, label: '난방' },
];

const lgWindSpeedOptions = [
  { value: 1, label: '약풍' },
  { value: 2, label: '중풍' },
  { value: 3, label: '강풍' },
  { value: 4, label: '최대' },
];
const samsungWindSpeedOptions = [
  { value: 1, label: '미풍' },
  { value: 2, label: '약풍' },
  { value: 3, label: '강풍' },
  { value: 4, label: '자동' },
];

const operModeOptions = computed(() => {
  return airconProduct.value === 'Samsung' ? samsungOperModeOptions : lgOperModeOptions;
});

const windSpeedOptions = computed(() => {
  return airconProduct.value === 'Samsung' ? samsungWindSpeedOptions : lgWindSpeedOptions;
});

const buildSetPointPayload = (extra = {}) => ({
  displayName_ID: 1,
  airconID: `${airconIndoorAddress.value}`.trim(),
  airconProduct: airconProduct.value,
  airconCassetteCount: Number(airconCassetteCount.value),
  airconGWAddress: Number(airconGwAddress.value),
  airconWindSpeed: Number(airconWindSpeed.value),
  airconOper: Number(airconOperMode.value),
  ...extra,
});

/** 화면의 6개 에어컨 설정을 item.aircon 형태로 */
const buildAirconPersistPatch = () => ({
  windSpeed: Number(airconWindSpeed.value),
  operMode: Number(airconOperMode.value),
  indoorAddress: `${airconIndoorAddress.value}`.trim(),
  cassetteCount: Number(airconCassetteCount.value),
  gwAddress: Number(airconGwAddress.value),
  product: airconProduct.value,
});

const persistAirconItem = async (airconPatch) => {
  const aircon = {
    ...getAirconItem(),
    ...airconPatch,
  };
  await requestUpdateDevice(device.value, { item: { aircon } });
  return aircon;
};

/** 어떤 필드를 적용해도 6개 값을 한 ISSETPOINT MQTT + DB 저장 */
const publishAirconConfigBundle = async () => {
  if (!device.value) {
    return;
  }
  emitter.emit('showLoading');
  try {
    const payload = buildSetPointPayload();
    mqttControl.onPublishTemp(
      device.value.controllerId,
      MQTTTempCommand.AirconSetPoint,
      payload,
    );
    await persistAirconItem(buildAirconPersistPatch());
    setTimeout(() => emitter.emit('hideLoading'), ButtonConfig.delay);
  } catch (err) {
    emitter.emit('hideLoading');
  }
};

const onApplyWindSpeed = () => {
  publishAirconConfigBundle();
};

const onApplyOperMode = () => {
  publishAirconConfigBundle();
};

const onApplyIndoorAddress = () => {
  publishAirconConfigBundle();
};

const onApplyCassetteCount = () => {
  publishAirconConfigBundle();
};

const onApplyGwAddress = () => {
  publishAirconConfigBundle();
};

const onApplyProduct = () => {
  publishAirconConfigBundle();
};

const onMinusClick = (event) => {
  event.preventDefault();
  event.stopPropagation();
  calibration.value = calibration.value <= -8.0 ? -8.0 : calibration.value - 0.5;
};

const onPlusClick = (event) => {
  event.preventDefault();
  event.stopPropagation();
  calibration.value = calibration.value >= 8.0 ? 8.0 : calibration.value + 0.5;
};

const onApplyCalibrationClick = async (event) => {
  event.preventDefault();
  event.stopPropagation();
  emitter.emit('showLoading');
  try {
    await requestUpdateDevice(device.value, { item: { calibration: calibration.value } });
    mqttControl.onPublishTemp(device.value.controllerId, MQTTTempCommand.TempCalibrationSet, `${calibration.value * 10}`);
    setTimeout(() => emitter.emit('hideLoading'), ButtonConfig.delay);
  } catch (err) {
    emitter.emit('hideLoading');
  }
};

const onApplyDarkMode = async () => {
  if (!device.value || !supportsDarkMode.value) {
    return;
  }
  emitter.emit('showLoading');
  try {
    const start = normalizeTimeValue(darkModeStart.value, '21:00');
    const end = normalizeTimeValue(darkModeEnd.value, '06:00');
    darkModeStart.value = start;
    darkModeEnd.value = end;
    const mode = Number(darkMode.value);
    const payload = {
      darkMode: mode,
      darkModeStart: start,
      darkModeEnd: end,
    };
    mqttControl.onPublishTemp(device.value.controllerId, MQTTTempCommand.DarkModeSet, payload);
    await requestUpdateDevice(device.value, { item: payload });
    setTimeout(() => emitter.emit('hideLoading'), ButtonConfig.delay);
  } catch (err) {
    emitter.emit('hideLoading');
  }
};

const onCancelClick = () => {
  if (props.cancelCallback) {
    props.cancelCallback();
  }
};

const onOkClick = () => {
  onCancelClick();
};

const onAllowSyncChange = async (e) => {
  emitter.emit('showLoading');
  try {
    mqttControl.onPublishTemp(device.value.controllerId, MQTTTempCommand.ScheduleSyncSet, e.target.checked ? '1' : '0');
    store.commit('home/updateDevice', {
      groupId: group.value._id,
      id: device.value._id,
      data: {
        item: { allowSync: e.target.checked ? 1 : 0 }
      },
    });

    const schedules = await requestSchedules();
    if (!schedules || schedules.length == 0) {
      await initSchedules();
    }
    setTimeout(() => emitter.emit('hideLoading'), ButtonConfig.delay);
  } catch (err) {
    emitter.emit('hideLoading');
  }
};

const initSchedules = async () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  const params = {
    title: "예약",
    deviceId: device.value._id,
    week: [1, 1, 1, 1, 1, 1, 1],
    data: Array.from({ length: 12 }).map((_, i) => ({
      id: i + 1,
      start: moment(new Date(year, month, day, i * 2, 0, 0)).format("HH:mm"),
      end: i == 11 ? "24:00" : moment(new Date(year, month, day, (i + 1) * 2, 0, 0)).format("HH:mm"),
      temp: 18.0,
      pattern: 0,
      enabled: true,
    }))
  };

  const mqttPayload = buildTimerGroupMqttPayload({
    enable: 0,
    days: "SMTWTFS",
    data: params.data,
  });

  await Promise.all(Array.from({ length: 3 }).map(async () => {
    await requestRegistSchedule({
      ...params,
      title: params.title
    });
    mqttControl.onPublishTemp(device.value.controllerId, MQTTTempCommand.SyncTimerGroup + `${1}`, mqttPayload);
  }));
};

const requestRegistSchedule = async (params) => {
  try {
    const result = await Axios.post(ScheduleApi.REGIST_SCHEDULE, params);
    if (result.resultCode !== '0000') {
      console.warn(result.resultMessage);
    }
  } catch (error) {
    console.log(error);
  }
};

const requestSchedules = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.get(ScheduleApi.SCHEDULES, { deviceId: device.value._id });
      if (result.resultCode === '0000') {
        resolve(result.resultData);
      } else {
        console.warn(result.resultMessage);
        reject();
      }
    } catch (error) {
      console.log(error);
      reject();
    }
  });
};

const onPattern2xChange = (e) => {
  emitter.emit('showLoading');
  try {
    mqttControl.onPublishTemp(device.value.controllerId, MQTTTempCommand.PatternMode2xSet, e.target.checked ? '1' : '0');
    store.commit('home/updateDevice', {
      groupId: group.value._id,
      id: device.value._id,
      data: {
        item: { pattern2x: e.target.checked ? 1 : 0 }
      },
    });
    setTimeout(() => emitter.emit('hideLoading'), ButtonConfig.delay);
  } catch (err) {
    emitter.emit('hideLoading');
  }
};

const onScheduleClick = () => {
  router.push(`/settings/temp/schedule/${group.value._id}/${device.value._id}`);
};

const requestUpdateDevice = async (device, params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.patch(
        DeviceApi.UPDATE_DEVICE.replace(':id', device._id),
        params,
      );
      if (result.resultCode === '0000') {
        store.commit('home/updateDevice', {
          groupId: group.value._id,
          id: device._id,
          data: params,
        });
        resolve(true);
        return;
      }
      reject("장치 수정에 실패했습니다.");
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};
</script>

<style scoped>
.touch-optimized {
  touch-action: manipulation !important;
  -webkit-tap-highlight-color: transparent !important;
}

.btn.touch-optimized {
  touch-action: manipulation !important;
  -webkit-tap-highlight-color: transparent !important;
}

.form-check-input.touch-optimized {
  touch-action: manipulation !important;
  -webkit-tap-highlight-color: transparent !important;
}

.apply-btn {
  min-width: 52px;
  border-radius: 7px;
}

/* 보일러 장치설정: 전 행 공통 그리드 (오른쪽 끝선 통일) */
.boiler-settings {
  width: 100%;
  text-align: left;
  padding: 0;
}

.setting-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.85rem;
  margin-bottom: 0.65rem;
  min-height: 2rem;
}

.setting-label {
  flex: 0 0 5.75rem;
  width: 5.75rem;
  max-width: 5.75rem;
  font-size: 0.95rem;
  line-height: 1.25;
  white-space: nowrap;
  text-align: left;
}

.setting-label-long {
  flex: 1 1 auto;
  width: auto;
  max-width: none;
  min-width: 0;
}

.setting-field {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.setting-trailing-icon {
  font-size: 0.8rem;
  color: #6c757d;
}

.setting-field .form-check-input {
  margin-top: 0;
  float: none;
}

/* 온도보정·다크모드: 입력 + 적용 (적용은 오른쪽 끝) */
.setting-controls {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-end;
  gap: 0.45rem;
  width: 100%;
  min-width: 0;
}

.setting-controls-main {
  flex: 0 1 7.5rem;
  min-width: 0;
  max-width: 7.5rem;
}

.setting-controls-main.btn-group {
  display: flex;
  width: 100%;
}

.setting-stepper-btn {
  flex: 0 0 34px;
  width: 34px;
  padding-left: 0;
  padding-right: 0;
}

.setting-stepper-btn:first-child {
  border-radius: 7px 0 0 7px;
}

.setting-stepper-btn:last-child {
  border-radius: 0 7px 7px 0;
}

.setting-stepper-val {
  flex: 1 1 auto;
  min-width: 0;
  padding-left: 0;
  padding-right: 0;
}

.setting-controls-apply {
  flex: 0 0 auto;
  flex-shrink: 0;
}

.setting-controls-apply .btn {
  width: auto;
  min-width: 3.25rem;
  padding-left: 0.65rem;
  padding-right: 0.65rem;
  border-radius: 7px;
  white-space: nowrap;
  writing-mode: horizontal-tb;
  flex-shrink: 0;
}

.dark-mode-select {
  width: 100%;
  border-radius: 7px;
}

/* 시작/종료시간: 적용 버튼 영역과 같은 오른쪽 끝선 */
.setting-time-selects {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-end;
  gap: 0.35rem;
  width: 100%;
  max-width: 11.2rem;
}

.dark-mode-time-part {
  flex: 1 1 0;
  min-width: 0;
  border-radius: 7px;
}

.dark-mode-time-sep {
  flex: 0 0 auto;
  font-weight: 600;
  color: #6c757d;
}

.dark-mode-hint {
  font-size: 0.75rem;
  line-height: 1.35;
  text-align: left;
  margin: 0.15rem 0 0.55rem;
  padding-left: 0.1rem;
}
</style>
